import React from "react";
import CorporateUsers from "../../Components/Member/CorporateUsers";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const CorporateUsersPage = ({ match, location }) => {
  const query = queryString.parse(location.search);
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <CorporateUsers pageNumber={query.pageNumber} search={query.search} />
    </React.Fragment>
  );
};

export default CorporateUsersPage;
